exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".trend-sticker{color:#fff;display:inline-block}", ""]);

